export default "/_next/static/images/8dc422b6d6626b07a29f8dae92748cc7.png";